<style>
  .ngx-datatable .datatable-header {
    overflow: auto !important;
  }
</style>

<div #gridRow>
  <!--grid show-->
  <div class="col-12 p-0" #tableWrapper>
    <ngx-datatable
      #gridSystem
      class="data-table ngx-datatable"
      [rows]="pagination.data"
      [columns]="columns"
      [columnMode]="'force'"
      [headerHeight]="50"
      [footerHeight]="50"
      [externalPaging]="true"
      [count]="searchQuery.count"
      [offset]="searchQuery.offset"
      [limit]="searchQuery.limit"
      (page)='onPage($event)'
      [externalSorting]="true"
      [loadingIndicator]="loadingIndicator"
      (sort)="onSort($event)"
      [rowHeight]="'auto'"
    >
      <ngx-datatable-footer>
        <ng-template
          ngx-datatable-footer-template
          let-rowCount="rowCount"
          let-pageSize="pageSize"
          let-selectedCount="selectedCount"
          let-curPage="curPage"
          let-offset="offset"
          let-isVisible="isVisible">
          <div class="c-absolute-class col-md-4 ps-0">
            {{(searchQuery.limit * (searchQuery.offset + 1) - searchQuery.limit) + 1}} {{"grid.to"|translate}} {{(searchQuery.limit * (searchQuery.offset + 1)) >= searchQuery.count ? searchQuery.count : (searchQuery.limit * (searchQuery.offset + 1))}}
            - {{searchQuery.count}} {{"grid.items"|translate}}
            <div class="text-start">
            </div>
          </div>
          <datatable-pager
            [pagerLeftArrowIcon]="'datatable-icon-left'"
            [pagerRightArrowIcon]="'datatable-icon-right'"
            [pagerPreviousIcon]="'datatable-icon-prev'"
            [pagerNextIcon]="'datatable-icon-skip'"
            [page]="curPage"
            [size]="pageSize"
            [count]="rowCount"
            [hidden]="!((rowCount / pageSize) > 1)"
            (change)="table.onFooterPage($event)"
          >
          </datatable-pager>
        </ng-template>
      </ngx-datatable-footer>

      <ng-template #numberColumnVal let-row="row" let-column="column" let-value="value" let-i="index">
        <div class="form-group row">
          <div class="col-10  text-center">
            <input type="number" [name]="'position'+row.id" [disabled]="disabledPosition" [value]="value" min="-1"
                   (blur)="column.change($event,row)" class="form-control">
          </div>
        </div>
      </ng-template>

      <ng-template #numberColumnHeader let-column="column" let-sortDir="sortDir" let-sortFn="sortFn">
        <p  class=" datatable-header-cell-label" (click)="sortFn()"
            [title]="column.translate?(column.name |translate):column.name">{{column.translate ? (column.name |translate) : column.name}}
          <span *ngIf="column.sortable">
              <i class="sortArrow sortArrowDown fa fa-long-arrow-down pt-1" [ngStyle]="{'opacity': (sortDir!=='desc') ? 0.3 : 0.8}"></i>
            </span>
          <span *ngIf="column.sortable">
              <i class="sortArrow fa fa-long-arrow-up pt-1" [ngStyle]="{'opacity': (sortDir!=='asc') ? 0.3 : 0.8}"></i>
            </span>
        </p>
      </ng-template>


      <!--  TEXT COLUMN  -->
      <ng-template #textColumnVal let-row="row" let-column="column" let-value="value" let-i="index">
        <div class="data-table-inner-value" [style.padding]="column.paddingVal"
             [ngClass]="{'text-truncate': !column.noTruncate}">
          <span *ngIf="column.isHtml && !column.valueTemplate" [innerHTML]="value"></span>
          <div *ngIf="!column.isHtml && !column.valueTemplate && column.hasStatus" style="display: flex">
            <span
              [class]="column.valueClassFormatter?column.valueClassFormatter(value):''">{{column.valueFormatter ? column.valueFormatter(value) : (column.translateValue ? (value|translate) : value)}} </span><span
            class="status-days">{{column.valueStatusFormatter ? column.valueStatusFormatter(row) : ''}}</span></div>
          <span *ngIf="!column.isHtml && !column.valueTemplate && !column.hasStatus"
                [class]="column.valueClassFormatter?column.valueClassFormatter(value):''">{{column.valueFormatter ? column.valueFormatter(value) : (column.translateValue ? (value|translate) : value)}}</span>
          <ng-template *ngIf="column.valueTemplate" [ngTemplateOutlet]="column.valueTemplate"
                       [ngTemplateOutletContext]="{ value: value, row: row, column: column }">
          </ng-template>
        </div>
      </ng-template>
      <ng-template #textColumnHeader let-column="column" let-sortDir="sortDir" let-sortFn="sortFn">
        <div *ngIf="!column.possibleItems" [title]="column.translate?(column.name |translate):column.name">
          <p  class=" datatable-header-cell-label" (click)="sortFn()"
              [title]="column.translate?(column.name |translate):column.name">{{column.translate ? (column.name |translate) : column.name}}
            <span *ngIf="column.sortable">
              <i class="sortArrow sortArrowDown fa fa-long-arrow-down pt-1" [ngStyle]="{'opacity': (sortDir!=='desc') ? 0.3 : 0.8}"></i>
            </span>
            <span *ngIf="column.sortable">
              <i class="sortArrow fa fa-long-arrow-up pt-1" [ngStyle]="{'opacity': (sortDir!=='asc') ? 0.3 : 0.8}"></i>
            </span>
          </p>
        </div>
      </ng-template>

    </ngx-datatable>
  </div>
</div>

